export const SHOW_GENERAL_LOADER = "SHOW_GENERAL_LOADER";
export const HIDE_GENERAL_LOADER = "HIDE_GENERAL_LOADER";
